export default {
  mySubStr: function (str, len) {
    /**
     * js截取字符串，中英文都能用
     * @param str：需要截取的字符串
     * @param len: 需要截取的长度
     */
    var str_length = 0
    var str_len = 0
    var str_cut = new String()
    str_len = str.length
    for (var i = 0; i < str_len; i++) {
      var a = str.charAt(i)
      str_length++
      if (escape(a).length > 4) {
        // 中文字符的长度经编码之后大于4
        str_length++
      }
      str_cut = str_cut.concat(a)
      if (str_length >= len) {
        str_cut = str_cut.concat('...')
        return str_cut
      }
    }
    // 如果给定字符串小于指定长度，则返回源字符串；
    if (str_length < len) {
      return str
    }
  },
  // 时间戳转换时间格式 年-月-日
  transferTime: function (time) {
    var month = time.getMonth() + 1
    var date = time.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (date < 10) {
      date = '0' + date
    }
    return time.getFullYear() + '-' + month + '-' + date
  },
  removeElementInArray: function (value, arr) {
    for (var i in arr) {
      if (arr[i].id == value) {
        arr.splice(i, 1)
        break
      }
    }
  }
}
